import React from "react";
import { useSelector } from "react-redux";
import { isMobileMode } from "../../../modules/configuration";
import { getLocale, IT } from "../../../modules/language";
import { enInformativa } from "./enInformativa";
import { itInformativa } from "./itInformativa";

export const Informativa = () => {
  const mobileMode = useSelector(isMobileMode);
  const locale = useSelector(getLocale);

  return (
    <div className={mobileMode ? "informativaMobile" : "informativa"}>
      {locale === IT ? itInformativa : enInformativa}
    </div>
  );
};
